
const response = {
    class_type: null,
    value: "",
    other_text: "",
    unavailable: null,
    is_valid: true,
    validation_messages: []
}

const updateQuestionData = {
    pageIndex: 0,
    clusterIndex: null,
    questionIndex: null,
    moduleId: 0,
    questionNo: '',
    classType: null,
    response,
    question: null
}

const updateQuestionVisibilityData = {
    clusterIndex: null,
    questionIndex: null,
    pageIndex: null,
    moduleId: 0,
    questionId: '',
    classType: null,
    isVisible: true
}

const updateQuestionCommentData = {
    pageIndex: null,
    clusterIndex: null,
    questionIndex: null,
    moduleId: 0,
    questionId: '',
    comment: {}
}

const updateReviewQuestionCommentData = {
    pageIndex: 0,
    clusterIndex: null,
    questionIndex: null,
    moduleId: 0,
    questionId: '',
    comment: {}
}


export const updateQuestionDataValue = (props: any, classType: any, value: any, unavailable: any, otherText: any, isValid: any, validationMessages: any) => {
    updateQuestionData.pageIndex = props.pageNumber - 1 ;
    updateQuestionData.clusterIndex = props.clusterIndex;
    updateQuestionData.questionIndex = props.questionIndex;
    updateQuestionData.moduleId = props.question.module_id;
    updateQuestionData.questionNo = props.question.question_number;
    updateQuestionData.response.class_type = classType;

    updateQuestionData.response.value = value;
    updateQuestionData.classType = classType;
    updateQuestionData.response.unavailable = unavailable;
    updateQuestionData.response.other_text = otherText;
    updateQuestionData.response.is_valid = isValid;
    updateQuestionData.response.validation_messages = validationMessages;


    props.updateQuestion(updateQuestionData);
}

export const updateQuestionVisibility = (props: any, questionMetadata: any, isVisible: any) => {
    updateQuestionVisibilityData.pageIndex = questionMetadata.pageIndex;
    updateQuestionVisibilityData.clusterIndex = questionMetadata.clusterIndex;
    updateQuestionVisibilityData.questionIndex = questionMetadata.questionIndex;
    updateQuestionVisibilityData.questionId = questionMetadata.questionId;
    updateQuestionVisibilityData.isVisible = isVisible;

    props.updateQuestionVisibility(updateQuestionVisibilityData);
}

export const addQuestionComment = (props: any, comment: any) => {
    updateQuestionData.pageIndex = props.pageNumber - 1 ;
    updateQuestionCommentData.clusterIndex = props.clusterIndex;
    updateQuestionCommentData.questionIndex = props.questionIndex;
    updateQuestionCommentData.comment = comment;

    props.addQuestionComment(updateQuestionCommentData);
}

export const updateQuestionValue = (props: any, pageIndex: any, clusterIndex: any, questionIndex: any, questionNumber: any, classType: any, value: any, unavailable: any, otherText: any, isValid: any, validationMessages: any, isVisibleDepend?: boolean) => {
    updateQuestionData.pageIndex = pageIndex;
    updateQuestionData.clusterIndex = clusterIndex;
    updateQuestionData.questionIndex = questionIndex;
    updateQuestionData.questionNo = questionNumber;
    updateQuestionData.response.class_type = classType;

    updateQuestionData.response.value = value;
    updateQuestionData.classType = classType;
    updateQuestionData.response.unavailable = unavailable;
    updateQuestionData.response.other_text = otherText;
    updateQuestionData.response.is_valid = isValid;
    updateQuestionData.response.validation_messages = validationMessages;


    props.updateQuestion(updateQuestionData, isVisibleDepend);
}

// add review question comment
export const addReviewQuestionComment = (props: any, comment: any) => {
    updateReviewQuestionCommentData.pageIndex = props.pageNumber - 1;
    updateReviewQuestionCommentData.clusterIndex = props.clusterIndex;
    updateReviewQuestionCommentData.questionIndex = props.questionIndex;
    updateReviewQuestionCommentData.moduleId = props.question.module_id;
    updateReviewQuestionCommentData.questionId = props.question.question_id;
    updateReviewQuestionCommentData.comment = comment;

    props.addQuestionComment(updateReviewQuestionCommentData);
}

// update admin level question
export const updateAdminLevelQuestionDataValue = (props: any, classType: any, value: any, unavailable: any, otherText: any, isValid: any, validationMessages: any, question: any) => {
    updateQuestionData.pageIndex = props.pageNumber - 1;
    updateQuestionData.clusterIndex = props.clusterIndex;
    updateQuestionData.questionIndex = props.questionIndex;
    updateQuestionData.moduleId = props.question.module_id;
    updateQuestionData.questionNo = question.question_number;
    updateQuestionData.response.class_type = classType;
    updateQuestionData.response.value = value;
    updateQuestionData.classType = classType;
    updateQuestionData.response.unavailable = unavailable;
    updateQuestionData.response.other_text = otherText;
    updateQuestionData.response.is_valid = isValid;
    updateQuestionData.response.validation_messages = validationMessages;
    updateQuestionData.question = question

    props.updateQuestion(updateQuestionData);
}



// WEBPACK FOOTER //
// ./src/effects/utils/preview.tsx